import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

const FormSkeleton = () => {
  return (
    <Box sx={{ width: '100%', mt: 2 }}>
      {/* Accordion Header Skeleton */}
      <Skeleton
        variant="rectangular"
        height={48}
        sx={{ mb: 2, borderRadius: 1 }}
      />

      {/* Form Fields Skeleton */}
      <Box sx={{ p: 2 }}>
        <Grid container spacing={3}>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <Grid
              key={item}
              size={{
                xs: 12,
                sm: 6,
                md: 4,
              }}
            >
              <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
              <Skeleton
                variant="rectangular"
                height={40}
                sx={{ borderRadius: 1 }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default FormSkeleton;
